import Vue from "vue";
import Vuex from "vuex";
import { baseAxios } from "../axios/base";
import { apiAxios } from "../axios/api";
import { configAxios } from "../axios/config";
import createLogger from "vuex/dist/logger";
import {
  uploadOptionsConverter,
  uploadOptionsCSSConverter,
  uploadOptionsJSConverter,
} from "@/utils/upload";

import inlineModeSMV from "@/store/modules/inlineModeSMV";
import model from "@/store/modules/model";
import panorama from "@/store/modules/panorama";
import video from "@/store/modules/video";
import script from "@/store/modules/script";
import config from "@/store/modules/config";
import copy from "@/store/modules/copy";
import spinControl from "@/store/modules/spinControl";
import textarea from "@/store/modules/textarea";

const plugins = [];

if (process.env.NODE_ENV !== "production") {
  plugins.push(createLogger());
}

Vue.use(Vuex);

//Todo separate all features to modules.
//Todo change Uppercase mutations names to lowercase

export default new Vuex.Store({
  plugins: plugins,
  state: {
    mode: "script",
    example: "default",
    statusAssetsForm: false,
    settings: {
      data: [],
      options: "",
      optionsMobile: "",
      optionsCSS: [],
      smv: [],
    },
    clearOptions: false,
    clearOptionsCSS: false,
    clearOptionsJS: false,
    zoomEnable: true,
    collapseOptions: [],
    collapseOptionsMobile: [],
    collapseOptionsCSS: [],
    collapseOptionsJS: [],
    initDataLoaded: {
      status: null,
      title: "",
      text: "",
    },
    enableMobileOptions: false,
    viewSMVMode: false,
    uploadedConfig: null,
    configUrl: null,
  },
  mutations: {
    ADD_SMV_ITEM(state, payload) {
      const find = state.settings.smv.find((smvItem) => smvItem.id === payload.id);
      if (find === undefined) {
        state.settings.smv.push(payload);
        state.settings.data.map((dataItem) =>
          dataItem.id === payload.id ? (dataItem.added = true) : dataItem
        );
      } else {
        const currentIndex = state.settings.smv.findIndex((smvItem) => smvItem.id === payload.id);
        state.settings.smv.splice(currentIndex, 1);
        state.settings.data.map((dataItem) =>
          dataItem.id === payload.id ? (dataItem.added = false) : dataItem
        );
      }
    },
    enableOnlyOneSpin(state) {
      const filteredData = state.settings.data.map((i) => {
        i.added = false;
        return i;
      });
      const checkOneSpinIndex = filteredData.findIndex((i) => i.type === "spins");
      filteredData[checkOneSpinIndex].added = true;
      const filteredSMV = state.settings.smv.filter((i) => i.type === "spins");
      const filteredOneSpinSMV = filteredSMV.length > 1 ? [filteredSMV[0]] : filteredSMV;
      state.settings.data = filteredData;
      state.settings.smv = filteredOneSpinSMV;
    },
    ADD_CUSTOM_ASSETS(state, payload) {
      state.settings.data = [...payload];
    },
    CHANGE_OPTION(state, payload) {
      state.settings.options = payload;
    },
    CHANGE_OPTION_MOBILE(state, payload) {
      state.settings.optionsMobile = payload;
    },
    CHANGE_OPTION_CSS(state, payload) {
      state.settings.optionsCSS = [...payload];
    },
    ENABLE_ZOOM(state, payload) {
      state.zoomEnable = payload;
    },
    SHOW_ASSETS_FORM(state, payload) {
      state.statusAssetsForm = payload;
    },
    CLEAR_ASSETS(state) {
      state.settings.data = [];
    },
    CLEAR_SMV(state) {
      state.settings.smv = [];
    },
    REFRESH_SMV(state) {
      const refreshedData = state.settings.data.filter((data) => data.added === true);
      state.settings.smv = [...refreshedData];
    },
    CHANGE_CLEAR_OPTIONS(state, payload) {
      state.clearOptions = payload;
    },
    CHANGE_CLEAR_OPTIONS_CSS(state, payload) {
      state.clearOptionsCSS = payload;
    },
    CHANGE_SVM(state, payload) {
      state.settings.smv = payload;
    },
    changeClearOptionsJS(state, payload) {
      state.clearOptionsJS = payload;
    },
    changeExample(state, payload) {
      let zoomEnable = false;
      if (payload.example === "default") {
        zoomEnable = true;
      }
      state.initDataLoaded = {};
      state.mode = "inline";
      state.statusAssetsForm = false;
      state.settings.options = "";
      state.settings.optionsMobile = "";
      state.settings.optionsCSS = [];
      state.clearOptions = true;
      state.clearOptionsCSS = true;
      state.clearOptionsJS = true;
      state.example = payload.example;
      state.initDataLoaded = payload.initDataLoaded;
      state.settings.data = payload.data || [];
      state.settings.smv = payload.smv || [];
      state.collapseOptionsCSS = payload.collapseOptionsCSS || [];
      state.collapseOptions = payload.collapseOptions || [];
      state.collapseOptionsMobile = payload.collapseOptionsMobile || [];
      state.collapseOptionsJS = payload.collapseOptionsJS || [];
      state.zoomEnable = zoomEnable;
    },
    changeMode(state, payload) {
      state.mode = payload;
    },
    initData(state, payload) {
      state.clearOptions = true;
      state.clearOptionsCSS = true;
      state.clearOptionsJS = true;
      state.settings.data = payload.data || [];
      state.collapseOptions = payload.collapseOptions || [];
      state.collapseOptionsCSS = payload.collapseOptionsCSS || [];
      state.collapseOptionsMobile = payload.collapseOptionsMobile || [];
      state.collapseOptionsJS = payload.collapseOptionsJS || [];
      state.settings.smv = payload.smv || [];
      setTimeout(() => {
        state.initDataLoaded = payload.initDataLoaded;
      }, 500);
    },
    SET_ENABLE_MOBILE_OPTIONS(state, payload) {
      state.enableMobileOptions = payload;
    },
    changeViewSMVMode(state, payload) {
      state.viewSMVMode = payload;
    },

    resetUploadedConfig(state) {
      state.uploadedConfig = null;
    },
    resetConfigUrl(state) {
      state.configUrl = null;
    },
    setUploadConfig(state, payload) {
      state.uploadedConfig = payload;
    },
    setConfigUrl(state, payload) {
      state.configUrl = payload;
    },
  },
  actions: {
    enableOnlyOneSpin({ commit }) {
      commit("enableOnlyOneSpin");
    },
    async initData({ commit, dispatch }) {
      await baseAxios
        .get("default.json")
        .then((r) => {
          if (r.status == 200) {
            const data = [...r.data.assets];
            const smv = [...r.data.config];
            const collapseOptions = [...r.data.options];
            const collapseOptionsCSS = [...r.data.cssoptions];
            const collapseOptionsMobile = [...r.data.optionsMobile];
            const collapseOptionsJS = [...r.data.jsoptions];
            commit("initData", {
              data: data,
              smv: smv,
              collapseOptions: collapseOptions,
              collapseOptionsCSS: collapseOptionsCSS,
              collapseOptionsMobile: collapseOptionsMobile,
              collapseOptionsJS: collapseOptionsJS,
            });
          }
        })
        .catch((e) => {
          return commit("initData", {
            initDataLoaded: {
              status: false,
              title: `Error`,
              text:
                `${e}. <br>Check your URLs or ` +
                `<a style="color: white; text-decoration: underline;" href="https://sirv.com/help/support">ask us for help</a>`,
            },
          });
        });
    },
    addSMVItem({ commit }, params) {
      commit("ADD_SMV_ITEM", params);
    },
    changeOptionMobile({ commit }, params) {
      commit("CHANGE_OPTION_MOBILE", params.option);
    },
    changeOption({ commit }, params) {
      commit("CHANGE_OPTION", params.option);
    },
    changeOptionCSS({ commit }, params) {
      commit("CHANGE_OPTION_CSS", params.optionCSS);
    },
    enableZoom({ commit }, params) {
      commit("ENABLE_ZOOM", params);
    },
    showAssetsForm({ commit }, params) {
      commit("SHOW_ASSETS_FORM", params);
    },
    addCustomAssets({ commit }, params) {
      commit("ADD_CUSTOM_ASSETS", params);
    },
    clearAssets({ commit }) {
      commit("CLEAR_ASSETS");
    },
    clearSMV({ commit }) {
      commit("CLEAR_SMV");
    },
    refreshSMV({ commit }) {
      commit("REFRESH_SMV");
    },
    changeClearOptions({ commit }, params) {
      commit("CHANGE_CLEAR_OPTIONS", params);
    },
    changeClearOptionsCSS({ commit }, params) {
      commit("CHANGE_CLEAR_OPTIONS_CSS", params);
    },
    changeClearOptionsJS({ commit }, params) {
      commit("changeClearOptionsJS", params);
    },
    async changeExample({ commit, dispatch }, parameter) {
      const params = parameter.type;
      const configUrl = parameter.query?.config ? parameter.query.config : null;
      const fileUrl = parameter.query?.file ? parameter.query.file : null;
      if (configUrl) {
        await configAxios
          .get(`/${configUrl}`)
          .then((r) => {
            if (
              r.status == 200 &&
              r.data?.assets &&
              r.data.assets.length &&
              r.data?.config &&
              r.data.config.length &&
              r.data?.options &&
              r.data.options.length &&
              r.data?.cssoptions &&
              r.data.cssoptions.length &&
              r.data?.optionsMobile &&
              r.data.optionsMobile.length &&
              r.data?.jsoptions &&
              r.data.jsoptions.length
            ) {
              const data = r.data.assets;
              const smv = r.data.config;
              const collapseOptions = r.data.options;
              const collapseOptionsCSS = r.data.cssoptions;
              const collapseOptionsMobile = r.data.optionsMobile;
              const collapseOptionsJS = r.data.jsoptions;
              const defaultUrls = data.map((d, i) => (i === 0 ? `` : "\n") + `${d.src}`).join("");
              dispatch("textarea/changeDefaultUrls", defaultUrls);

              commit("changeExample", {
                data: data,
                smv: smv,
                collapseOptions: collapseOptions,
                collapseOptionsCSS: collapseOptionsCSS,
                collapseOptionsMobile: collapseOptionsMobile,
                collapseOptionsJS: collapseOptionsJS,
                initDataLoaded: {
                  status: true,
                  title: "Success",
                  text: "Set was loaded correctly",
                },
                example: params,
              });
              dispatch("changeViewSMVMode", r.data.viewSMVMode ?? false);
            } else {
              console.log("Something went wrong");
              dispatch("config/changeErrorLoadConfigStatus", true);
              return null;
            }
          })
          .then((r) => {
            if (r === null) dispatch("initData");
          })
          .catch((e) => {
            console.log(e);
            return commit("changeExample", {
              data: [],
              smv: [],
              collapseOptions: [],
              collapseOptionsCSS: [],
              collapseOptionsMobile: [],
              collapseOptionsJS: [],
              initDataLoaded: {
                status: false,
                title: `Error`,
                text:
                  `${e.message}. <br>Check your URLs or ` +
                  `<a style="color: white; text-decoration: underline;" href="https://sirv.com/help/support">ask us for help</a>`,
              },
            });
          });
      } else if (fileUrl) {
        let fileName = fileUrl.split("=").pop();
        let fileExt = "." + fileUrl.split(".").pop();

        let modelTypes = [".glb", ".gltf"];
        let videoTypes = [
          ".mp4",
          ".m4v",
          ".mpg",
          ".mpeg",
          ".mov",
          ".wmv",
          ".avi",
          ".webm",
          ".mkv",
          ".ogv",
        ];
        let spinTypes = [".spin"];
        let imageTypes = [".jpg", ".png", "jpeg", ".gif", ".bmp"];
        let viewTypes = [".view"];

        let newType = modelTypes.includes(fileExt)
          ? "model"
          : videoTypes.includes(fileExt)
          ? "video"
          : spinTypes.includes(fileExt)
          ? "spins"
          : imageTypes.includes(fileExt)
          ? "image"
          : viewTypes.includes(fileExt)
          ? "view"
          : "";
        let newData = [{ id: 1, title: fileName, src: fileName, type: newType, added: true }];
        if (newType === "spins") {
          newData = [
            {
              id: 1,
              title: fileName,
              src: fileName,
              type: newType,
              added: true,
              spinsrc: fileName,
            },
          ];
        }

        await baseAxios
          .get("default.json")
          .then((r) => {
            if (r.status == 200) {
              const data = newData;
              const smv = newData;
              const collapseOptions = [...r.data.options];
              const collapseOptionsCSS = [...r.data.cssoptions];
              const collapseOptionsMobile = [...r.data.optionsMobile];
              const collapseOptionsJS = [...r.data.jsoptions];
              const defaultUrls = data.map((d, i) => (i === 0 ? `` : "\n") + `${d.src}`).join("");
              dispatch("textarea/changeDefaultUrls", defaultUrls);

              commit("changeExample", {
                data: data,
                smv: smv,
                collapseOptions: collapseOptions,
                collapseOptionsCSS: collapseOptionsCSS,
                collapseOptionsMobile: collapseOptionsMobile,
                collapseOptionsJS: collapseOptionsJS,
                initDataLoaded: {
                  status: true,
                  title: "Success",
                  text: "Set was loaded correctly",
                },
                example: params,
              });
              if (newType === "view") dispatch("changeViewSMVMode", true);
              dispatch("refreshSMV");
            }
          })
          .catch((e) => {
            return commit("initData", {
              initDataLoaded: {
                status: false,
                title: `Error`,
                text:
                  `${e}. <br>Check your URLs or ` +
                  `<a style="color: white; text-decoration: underline;" href="https://sirv.com/help/support">ask us for help</a>`,
              },
            });
          });
      } else {
        await baseAxios
          .get(`${params}.json`)
          .then((r) => {
            if (r.status == 200) {
              const data = [...r.data.assets];
              const smv = [...r.data.config];
              const collapseOptions = [...r.data.options];
              const collapseOptionsCSS = [...r.data.cssoptions];
              const collapseOptionsMobile = [...r.data.optionsMobile];
              const collapseOptionsJS = [...r.data.jsoptions];

              commit("changeExample", {
                data: data,
                smv: smv,
                collapseOptions: collapseOptions,
                collapseOptionsCSS: collapseOptionsCSS,
                collapseOptionsMobile: collapseOptionsMobile,
                collapseOptionsJS: collapseOptionsJS,
                initDataLoaded: {
                  status: true,
                  title: "Success",
                  text: "Set was loaded correctly",
                },
                example: params,
              });
            }
          })
          .catch((e) => {
            return commit("changeExample", {
              data: [],
              smv: [],
              collapseOptions: [],
              collapseOptionsCSS: [],
              collapseOptionsMobile: [],
              collapseOptionsJS: [],
              initDataLoaded: {
                status: false,
                title: `Error`,
                text:
                  `${e.message}. <br>Check your URLs or ` +
                  `<a style="color: white; text-decoration: underline;" href="https://sirv.com/help/support">ask us for help</a>`,
              },
            });
          });
      }
    },
    changeMode({ commit }, params) {
      commit("changeMode", params);
    },
    setEnableMobileOptions({ commit }, params) {
      commit("SET_ENABLE_MOBILE_OPTIONS", params);
    },
    changeViewSMVMode({ commit }, params) {
      commit("changeViewSMVMode", params);
    },

    resetUploadedConfig({ commit }) {
      commit("resetUploadedConfig");
    },
    resetConfigUrl({ commit }) {
      commit("resetConfigUrl");
    },
    async uploadConfig({ commit, state }, data) {
      const bearerToken = await apiAxios
        .post("token", {
          clientId: process.env.VUE_APP_SIRV_CLIENT_ID,
          clientSecret: process.env.VUE_APP_SIRV_CLIENT_SECRET,
        })
        .then((r) => (r.status === 200 ? r.data : null))
        .catch((e) => {
          console.log(e);
          return null;
        });

      const settingsOptions = state.settings.options;
      const settingsOptionsMobile = state.settings.optionsMobile;
      const settingsOptionsCSS = state.settings.optionsCSS;
      const spinControlPanelStatus = data.spinControlPanelStatus;
      const spinControlSelectedButtons = state.spinControl.selectedButtons;
      const spinControlSelectedPosition = state.spinControl.selectedPosition;
      const spinControlSelectedIconsStyle = state.spinControl.selectedIconsStyle;
      const spinControlBackground = state.spinControl.background;
      const spinControlIconsColor = state.spinControl.color;
      const spinControlIconsSize = state.spinControl.size;

      const spinControl = {
        spinControlPanelStatus: spinControlPanelStatus,
        spinControlSelectedButtons: spinControlSelectedButtons,
        spinControlSelectedPosition: spinControlSelectedPosition,
        spinControlSelectedIconsStyle: spinControlSelectedIconsStyle,
        spinControlBackground: spinControlBackground,
        spinControlIconsColor: spinControlIconsColor,
        spinControlIconsSize: spinControlIconsSize,
      };

      const appliedSettingsOptions = uploadOptionsConverter(
        state.collapseOptions,
        settingsOptions,
        spinControl
      );
      const appliedSettingsOptionsMobile = uploadOptionsConverter(
        state.collapseOptionsMobile,
        settingsOptionsMobile,
        spinControl
      );
      const appliedSettingsOptionsCSS = uploadOptionsCSSConverter(
        state.collapseOptionsCSS,
        settingsOptionsCSS
      );
      const appliedSettingsOptionsJS = uploadOptionsJSConverter(
        state.collapseOptionsJS,
        state.script
      );
      state.settings.optionsCSS;
      if (bearerToken !== null) {
        commit("setUploadConfig", bearerToken);

        return await apiAxios
          .post(
            `files/upload?filename=/configs/config-${data.date}.json`,
            JSON.stringify({
              assets: state.settings.data,
              config: state.settings.smv,
              options: appliedSettingsOptions,
              cssoptions: appliedSettingsOptionsCSS,
              optionsMobile: appliedSettingsOptionsMobile,
              jsoptions: appliedSettingsOptionsJS,
              viewSMVMode: state.viewSMVMode,
            }),
            {
              headers: {
                Authorization: `Bearer ${bearerToken.token}`,
                "Content-type": "application/json",
              },
            }
          )
          .then((r) => {
            if (r.status === 200) {
              const url = r.config.url.replace(
                "files/upload?filename=",
                "https://sirvwebsite.sirv.com"
              );
              commit("setConfigUrl", url);
              return { ok: true, url };
            }
            return { ok: false, reason: "unexpected_status" };
          })
          .catch((e) => {
            console.log(e);
            return { ok: false, reason: "upload_failed", error: e };
          });
      }
      return { ok: false, reason: "token_failed" };
    },
  },
  getters: {
    getImageAssets: (state) => state.settings.data.filter((item) => item.type === "image"),
    getSpinAssets: (state) => state.settings.data.filter((item) => item.type === "spins"),
    getVideoAssets: (state) => state.settings.data.filter((item) => item.type === "video"),
    getViewAssets: (state) => state.settings.data.filter((item) => item.type === "view"),
    getModelAssets: (state) => state.settings.data.filter((item) => item.type === "model"),
    getPanoramaAssets: (state) => state.settings.data.filter((item) => item.type === "panorama"),
    getDataCount: (state) => state.settings.data.length,
    getSMVItemsCount: (state) => state.settings.smv.length,
  },
  modules: {
    inlineModeSMV,
    panorama,
    model,
    video,
    script,
    config,
    spinControl,
    copy,
    textarea,
  },
});
